import { /*QuestFormatEnum,*/ QuestTypeEnum } from "sandpiper_api";
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";

// SVG icons
import questFormatIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_format.svg?raw";
import questTypeIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_type.svg";
import questIntensityIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_intensity.svg";
import questDurationIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_timeframe.svg";
import questLocationIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_location.svg";
import questMaterialIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_material.svg";
import questSubjectIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_subject.svg";
import questPointsIcon from "!raw-loader!@/assets/image/icons/filter/icon-filter_points.svg";

//const QUEST_FORMAT = new QuestFormatEnum();
const QUEST_TYPE = new QuestTypeEnum();

export default {
    components: { questFormatIcon, questTypeIcon },
    mixins: [ QuestTypeHelper, QuestPropertiesHelper ],
    data()
    {
        return {
            filterCategories: [
                {
                    key: "questType",
                    icon: questFormatIcon,
                    label: "Activiteit",
                    items: [
                        { value: QUEST_TYPE.more, label: this.questTypeToString(QUEST_TYPE.more) },
                        { value: QUEST_TYPE.smart, label: this.questTypeToString(QUEST_TYPE.smart) },
                        { value: QUEST_TYPE.together, label: this.questTypeToString(QUEST_TYPE.together) },
                        { value: QUEST_TYPE.impulse, label: this.questTypeToString(QUEST_TYPE.impulse) }
                    ]
                },
                /*
                {
                    key: "questFormat",
                    icon: questTypeIcon,
                    label: "Type",
                    items: [
                        { value: QUEST_FORMAT.standard, label: "Standaard" },
                        { value: QUEST_FORMAT.quiz, label: "Quiz" },
                        { value: QUEST_FORMAT.puzzle, label: "Puzzel" }
                    ]
                },
                 */
                {
                    key: "questIntensity",
                    icon: questIntensityIcon,
                    label: "Intensiteit",
                    items: this.questProperties.intensity.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                {
                    key: "questDuration",
                    icon: questDurationIcon,
                    label: "Tijdsduur",
                    items: this.questProperties.duration.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                {
                    key: "questLocation",
                    icon: questLocationIcon,
                    label: "Omgeving",
                    items: this.questProperties.location.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                {
                    key: "questMaterial",
                    icon: questMaterialIcon,
                    label: "Materiaal",
                    items: this.questProperties.material.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                {
                    key: "questSubject",
                    icon: questSubjectIcon,
                    label: "Vakdiscipline",
                    items: this.questProperties.subject.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                /*
                {
                    key: "questPartOfDay",
                    icon: questPartOfDayIcon,
                    label: "Dagdeel",
                    items: this.questProperties.partOfDay.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },
                {
                    key: "questTheme",
                    icon: questThemeIcon,
                    label: "Thema",
                    items: this.questProperties.theme.map(obj =>
                    {
                        return { value: obj.value, label: obj.name }
                    })
                },*/
                {
                    key: "questPoints",
                    icon: questPointsIcon,
                    label: "Batterijen",
                    items: [
                        { value: "1", label: "1" },
                        { value: "2", label: "2" },
                        { value: "3", label: "3" }
                    ]
                }
            ]
        }
    }
}